import { EsecutoreService } from './../services/esecutore.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { IEsecutore } from '../interfaces/IEsecutore';
import { DynamicDialogRef, DynamicDialogConfig, MenuItem } from 'primeng/api';
import * as Constants from '../utils/constants'
import * as Enum from '../utils/enums'
import { Loading } from '../utils/loading';
import { TranslateService } from '@ngx-translate/core';
import { AlertUtil } from '../utils/alert-util';
import { finalize } from 'rxjs/operators';
import { DocumentiService } from '../services/documenti.service';
import { RequestBuilder } from '../classes/request-builder';
import { Util } from '../utils/util';
import { OverlayPanel } from 'primeng/overlaypanel';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IAggiudicatario } from '../interfaces/IAggiudicatario';

@Component({
  selector: 'app-esecutore-modal',
  templateUrl: './esecutore-modal.component.html',
  styleUrls: ['./esecutore-modal.component.css']
})
export class EsecutoreModalComponent implements OnInit {

  @ViewChild('op') op: OverlayPanel

  esecutore: IEsecutore
  fromFiliera: boolean
  aggiudicatario: IAggiudicatario

  statiAntimafia: any[]
  itemsAllegato: MenuItem[];

  usernamePattern = "^[a-zA-Z0-9-_.!-]*$";
  maxPattern = "^[0-9]{1,11}$"
  cfPattern = "^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$"

  fileName: string  // name of file already uploaded
  uploadedFile: any //for upload file
  attachmentUrl: string = ""                  // url dell'allegato


  esecutoreForm: FormGroup
  isUpdate: boolean = false
  codiceFiscaleValid: boolean
  partitaIvaValid: boolean

  constructor(private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private translate: TranslateService,
    private alertUtil: AlertUtil,
    private documentiService: DocumentiService,
    private formBuilder: FormBuilder,
    private esecutoreService: EsecutoreService) {
    this.esecutore = this.config.data.esecutore
    this.aggiudicatario = this.config.data.aggiudicatario
    this.fromFiliera = this.config.data.fromFiliera

    this.fileName = this.esecutore && this.esecutore.CertificatoAntimafia ? this.esecutore.CertificatoAntimafia.Nome : null

    this.statiAntimafia = Constants.STATI_ANTIMAFIA
    this.isUpdate = this.esecutore ? true : false

    this.setStatoAntimafia();

  }

  private setStatoAntimafia() {
    if (this.esecutore && this.esecutore.Stato_antimafia == null) {
      this.esecutore.Stato_antimafia = this.statiAntimafia[0];
    } else if (this.aggiudicatario && this.aggiudicatario.Stato_antimafia == null) {
      this.aggiudicatario.Stato_antimafia = this.statiAntimafia[0];
    }
  }

  ngOnInit() {
    //build form group
    this.serForm();
    //controllo cambio valore codice fiscale
    this.codiceFiscale.valueChanges.subscribe(val => {
      //se non ci sono errori nel CF c'è un valore != null o != "" la partita iva non è obbligatoria
      if (!this.codiceFiscale.errors && val) {
        this.codiceFiscaleValid = true
        this.partitaIva.setValidators([Validators.max(99999999999), Validators.min(0), Validators.pattern(this.maxPattern)]);
        this.partitaIva.updateValueAndValidity();
      } else if (this.codiceFiscale.errors && !val) {
        this.codiceFiscaleValid = false
        if (!this.validatorPIva) {
          this.partitaIva.setValidators([Validators.required, Validators.max(99999999999), Validators.min(0), Validators.pattern(this.maxPattern)]);
          this.partitaIva.updateValueAndValidity();
        }
      } else {
        this.codiceFiscaleValid = false
      }

    })
    //controllo cambio valore partita iva
    this.partitaIva.valueChanges.subscribe(val => {
      //se non ci sono errori nella partitaIva e c'è un valore != null o != "" il CF non è obbligatorio
      if (!this.partitaIva.errors && val) {
        this.partitaIvaValid = true
        this.codiceFiscale.setValidators([Validators.max(99999999999), Validators.min(0)]);//, Validators.pattern(this.cfPattern)
        this.codiceFiscale.updateValueAndValidity();
      } else if (this.partitaIva.errors && !val) {
        this.partitaIvaValid = false
        if (!this.validatorCF) {
          this.codiceFiscale.setValidators([Validators.required, Validators.max(99999999999), Validators.min(0)]); //, Validators.pattern(this.cfPattern)
          this.codiceFiscale.updateValueAndValidity();
        }
      } else {
        this.partitaIvaValid = false
      }

    })
  }

  private serForm() {
    this.esecutoreForm = this.formBuilder.group({
      'username': [{ value: this.esecutore ? this.esecutore.Username : '', disabled: this.isUpdate }, Validators.compose([Validators.required, Validators.pattern(this.usernamePattern)])],
      'ragioneSociale': [this.esecutore ? this.esecutore.Ragione_sociale : '', Validators.required],
      'email': [this.esecutore ? this.esecutore.Email : '', Validators.compose([Validators.required, Validators.email])],
      'comune': [this.esecutore ? this.esecutore.Comune : '', Validators.required],
      'indirizzo': [this.esecutore ? this.esecutore.Indirizzo : '', Validators.required],
      'codiceFiscale': [this.esecutore ? this.esecutore.Codice_fiscale : '', this.getValidatorCompose("codiceFiscale")],
      'partitaIva': [this.esecutore ? this.esecutore.Partita_IVA : '', this.getValidatorCompose("partitaIva")] //, disabled: this.isUpdate
    });
  }

  private getValidatorCompose(itemType: string) {
    this.partitaIvaValid = this.isUpdate && this.esecutore && this.esecutore.Partita_IVA ? true : false
    this.codiceFiscaleValid = this.isUpdate && this.esecutore && this.esecutore.Codice_fiscale ? true : false
    let retString = itemType == "codiceFiscale" ? Validators.compose([Validators.required, Validators.max(99999999999), Validators.min(0)]) :
      Validators.compose([Validators.required, Validators.max(99999999999), Validators.min(0), Validators.pattern(this.maxPattern)])

    if (itemType == "codiceFiscale" && this.isUpdate && this.esecutore && this.esecutore.Partita_IVA
      || itemType == "partitaIva" && this.isUpdate && this.esecutore && this.esecutore.Codice_fiscale) {
      if (itemType == "codiceFiscale") {
        retString = Validators.compose([Validators.max(99999999999), Validators.min(0)])
      } else {
        retString = Validators.compose([Validators.max(99999999999), Validators.min(0), Validators.pattern(this.maxPattern)])
      }
    }
    return retString
  }

  // convenience getter for easy access to form fields
  get form() { return this.esecutoreForm.controls; }

  get codiceFiscale() {
    return this.esecutoreForm.get('codiceFiscale') as FormControl;
  }

  get partitaIva() {
    return this.esecutoreForm.get('partitaIva') as FormControl;
  }

  get validatorCF() {
    const validator = this.codiceFiscale.validator({} as AbstractControl);
    if (validator && validator.required) {
      return true;
    }
  }

  get validatorPIva() {
    const validator = this.partitaIva.validator({} as AbstractControl);
    if (validator && validator.required) {
      return true;
    }
  }

  onSubmit() {
    if (this.esecutoreForm.valid) {
      let esecutoreObj: any
      //retrieve values from form
      let username = this.esecutoreForm.controls['username'].value
      let ragioneSociale = this.esecutoreForm.controls['ragioneSociale'].value
      let email = this.esecutoreForm.controls['email'].value
      let comune = this.esecutoreForm.controls['comune'].value
      let indirizzo = this.esecutoreForm.controls['indirizzo'].value
      let codiceFiscale = this.esecutoreForm.controls['codiceFiscale'].value
      let partitaIva = this.esecutoreForm.controls['partitaIva'].value

      if (this.isUpdate) {
        esecutoreObj = {
          IdAzienda: this.esecutore.Id,
          RagioneSociale: ragioneSociale,
          Email: email,
          Comune: comune,
          Indirizzo: indirizzo,
          CodiceFiscale: codiceFiscale,
          PartitaIVA: partitaIva
        }
        this.callUpdateEsecutore(esecutoreObj)
      } else {
        esecutoreObj = {
          UserName: username,
          RagioneSociale: ragioneSociale,
          Email: email,
          Comune: comune,
          Indirizzo: indirizzo,
          CodiceFiscale: codiceFiscale,
          PartitaIVA: partitaIva
        }
        this.callSaveEsecutore(esecutoreObj)
      }
    }
  }

  /**
   * callback fired when save button is pressed
   */
  /* onSaveEsecutore() {
    Loading.isLoading = true
    let fileToUplaod = this.uploadedFile ? this.uploadedFile : new ArrayBuffer(0)

    this.documentiService.saveCertificatoAntimafia(fileToUplaod, String(this.esecutore.Id), this.fileName, this.esecutore.Stato_antimafia).pipe(
      finalize(() => {
        Loading.isLoading = false
      })
    ).subscribe(
      response => {
        if (response.data) {
          this.alertUtil.showAlert("LBL_SAVE_STATO_ANTIMAFIA", null, null, null, () => {
            this.ref.close(this.esecutore)
          })
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      }
    )

  } */

  /**
  * callback fired when file is uploaded
  * @param event file
  * @param upload 
  */
  uploadClick(event: any, upload: any) {
    this.uploadedFile = null
    upload.clear()
    if (event.files) {
      this.uploadedFile = event.files[0];
      this.fileName = this.uploadedFile.name
    }
  }

  /**
   * 
   * @param menu 
   * @param event
   */
  openMenu(menu, event) {
    this.optionsAllegato(event)
    menu.toggle(event)
  }

  /**
   * set options allegato
   * @param event 
   */
  private optionsAllegato(event: any) {
    this.translate.get(["LBL_ALLEGATO_APRI", "LBL_ALLEGATO_CANCELLA",]).subscribe(res => {
      this.itemsAllegato = [
        {
          label: res["LBL_ALLEGATO_APRI"], icon: 'pi pi-download', command: () => {
            this.openAllegato(event);
          }
        }
      ]
    })
  }

  /**
   * open allegato in other tab
   */
  openAllegato(event: any) {
    let requestBuilder = new RequestBuilder({
      IdCertificato: this.esecutore.CertificatoAntimafia.Id,
      IdAzienda: this.esecutore.Id
    })
    Loading.isLoading = true
    this.documentiService.downloadCertificatoAntimafia(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response && response["error"] == null) {
          //check allegato extension
          let allegatoType = this.esecutore.CertificatoAntimafia.Estensione.trim()
          let allegatoNome = this.esecutore.CertificatoAntimafia.Nome
          if (!allegatoType) {
            allegatoType = allegatoNome.substring(allegatoNome.lastIndexOf("."));
          }
          if (allegatoType == Enum.FILE_TYPE_ENUM.PDF) {
            Util.showPdf(response)
          } else if (allegatoType == Enum.FILE_TYPE_ENUM.JPEG || allegatoType == Enum.FILE_TYPE_ENUM.JPG
            || allegatoType == Enum.FILE_TYPE_ENUM.PNG) {
            this.attachmentUrl = "data:image/" + allegatoType + ";base64," + response
            //Apertura dell'overlay panel
            this.op.toggle(event)

          } else {
            Util.downloadFile(response, allegatoType, allegatoNome)
          }
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + JSON.stringify(response.error.Stack))
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      }
    )
  }

  /**
   * determines whether save button is disabled
   */
  isDisabledButton(): boolean {
    let isDisabled: boolean = true

    if (this.uploadedFile && this.fileName) {
      isDisabled = false
    }

    return isDisabled
  }

  /**
   * create esecutore
   * @param esecutoreObj esecutoreObj
   */
  callSaveEsecutore(esecutoreObj: IEsecutore) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(esecutoreObj)
    this.esecutoreService.save(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.alertUtil.showAlert("LBL_NEW_ESECUTORE_SUCCESS", null, null, null, () => {
            this.ref.close(esecutoreObj)
          })
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * update esecutore
   * @param esecutoreObj esecutoreObj
   */
  callUpdateEsecutore(esecutoreObj: IEsecutore) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(esecutoreObj)
    this.esecutoreService.update(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.alertUtil.showAlert("LBL_NEW_ESECUTORE_SUCCESS", null, null, null, () => {
            this.ref.close(esecutoreObj)
          })
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

}
